module.exports = __webpack_public_path__ + "static/media/ob3.69b58629.png";